import { MAP_CLUSTER_MARKERS_DISTANCE } from '../constants/config';
export function clusterByPixelDistance(pixelMarkers) {
    const clusters = [];
    const radiusPx = MAP_CLUSTER_MARKERS_DISTANCE;
    for (const pixelMarker of pixelMarkers) {
        let added = false;
        for (const cluster of clusters) {
            const deltaX = pixelMarker.positionX - cluster[0].positionX;
            const deltaY = pixelMarker.positionY - cluster[0].positionY;
            if (deltaX * deltaX + deltaY * deltaY < radiusPx * radiusPx) {
                cluster.push(pixelMarker);
                added = true;
                break;
            }
        }
        if (!added) {
            clusters.push([pixelMarker]);
        }
    }
    return clusters;
}
